 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		0: 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "" + ({"4":"component---cache-caches-gatsby-plugin-offline-app-shell-js","5":"component---src-pages-404-mdx","6":"component---src-pages-about-mdx","7":"component---src-pages-accessibility-mdx","8":"component---src-pages-downloads-disbursements-by-month-mdx","9":"component---src-pages-downloads-disbursements-mdx","10":"component---src-pages-downloads-federal-revenue-by-company-mdx","11":"component---src-pages-downloads-index-mdx","12":"component---src-pages-downloads-production-by-disposition-mdx","13":"component---src-pages-downloads-production-by-month-mdx","14":"component---src-pages-downloads-production-mdx","15":"component---src-pages-downloads-revenue-mdx","16":"component---src-pages-explore-index-mdx","17":"component---src-pages-explore-offshore-regions-alaska-mdx","18":"component---src-pages-explore-offshore-regions-atlantic-mdx","19":"component---src-pages-explore-offshore-regions-gulf-mdx","20":"component---src-pages-explore-offshore-regions-pacific-mdx","21":"component---src-pages-explore-states-ak-mdx","22":"component---src-pages-explore-states-al-mdx","23":"component---src-pages-explore-states-ar-mdx","24":"component---src-pages-explore-states-az-mdx","25":"component---src-pages-explore-states-ca-mdx","26":"component---src-pages-explore-states-co-mdx","27":"component---src-pages-explore-states-fl-mdx","28":"component---src-pages-explore-states-id-mdx","29":"component---src-pages-explore-states-il-mdx","30":"component---src-pages-explore-states-in-mdx","31":"component---src-pages-explore-states-ks-mdx","32":"component---src-pages-explore-states-ky-mdx","33":"component---src-pages-explore-states-la-mdx","34":"component---src-pages-explore-states-md-mdx","35":"component---src-pages-explore-states-mi-mdx","36":"component---src-pages-explore-states-mn-mdx","37":"component---src-pages-explore-states-mo-mdx","38":"component---src-pages-explore-states-ms-mdx","39":"component---src-pages-explore-states-mt-mdx","40":"component---src-pages-explore-states-nc-mdx","41":"component---src-pages-explore-states-nd-mdx","42":"component---src-pages-explore-states-ne-mdx","43":"component---src-pages-explore-states-nm-mdx","44":"component---src-pages-explore-states-nv-mdx","45":"component---src-pages-explore-states-ny-mdx","46":"component---src-pages-explore-states-oh-mdx","47":"component---src-pages-explore-states-ok-mdx","48":"component---src-pages-explore-states-or-mdx","49":"component---src-pages-explore-states-pa-mdx","50":"component---src-pages-explore-states-sc-mdx","51":"component---src-pages-explore-states-sd-mdx","52":"component---src-pages-explore-states-tx-mdx","53":"component---src-pages-explore-states-ut-mdx","54":"component---src-pages-explore-states-va-mdx","55":"component---src-pages-explore-states-wa-mdx","56":"component---src-pages-explore-states-wi-mdx","57":"component---src-pages-explore-states-wv-mdx","58":"component---src-pages-explore-states-wy-mdx","59":"component---src-pages-fact-sheet-mdx","60":"component---src-pages-glossary-mdx","61":"component---src-pages-how-revenue-works-aml-reclamation-program-mdx","62":"component---src-pages-how-revenue-works-audits-and-assurances-mdx","63":"component---src-pages-how-revenue-works-coal-excise-tax-mdx","64":"component---src-pages-how-revenue-works-coal-mdx","65":"component---src-pages-how-revenue-works-disbursements-mdx","66":"component---src-pages-how-revenue-works-federal-laws-mdx","67":"component---src-pages-how-revenue-works-federal-reforms-mdx","68":"component---src-pages-how-revenue-works-gomesa-mdx","69":"component---src-pages-how-revenue-works-hpf-mdx","70":"component---src-pages-how-revenue-works-index-mdx","71":"component---src-pages-how-revenue-works-lwcf-mdx","72":"component---src-pages-how-revenue-works-minerals-mdx","73":"component---src-pages-how-revenue-works-native-american-ownership-governance-mdx","74":"component---src-pages-how-revenue-works-native-american-production-mdx","75":"component---src-pages-how-revenue-works-native-american-revenue-mdx","76":"component---src-pages-how-revenue-works-offshore-oil-gas-mdx","77":"component---src-pages-how-revenue-works-offshore-renewables-mdx","78":"component---src-pages-how-revenue-works-onshore-oil-gas-mdx","79":"component---src-pages-how-revenue-works-onshore-renewables-mdx","80":"component---src-pages-how-revenue-works-ownership-mdx","81":"component---src-pages-how-revenue-works-reclamation-mdx","82":"component---src-pages-how-revenue-works-revenues-mdx","83":"component---src-pages-index-mdx","84":"component---src-pages-patterns-components-index-mdx","85":"component---src-pages-patterns-index-mdx","86":"component---src-pages-patterns-visual-styles-color-mdx","87":"component---src-pages-patterns-visual-styles-iconography-mdx","88":"component---src-pages-patterns-visual-styles-typography-mdx","89":"component---src-pages-query-data-mdx","90":"component---src-pages-search-results-mdx","91":"component---src-pages-vdp-mdx"}[chunkId]||chunkId) + "-" + {"4":"8f6257d1f267bc85f677","5":"d5b097a33b39e81ecb48","6":"6d7476acc9b25566af4d","7":"571cf18c0ae9b0dfb082","8":"c41b833c32a2030112d1","9":"ba6563546d6f08999072","10":"b4a44d7e536b8c1af9a7","11":"f8ece7e3394315a57cf7","12":"42e0ad66f55d7e7e0c26","13":"cc6034878350dd849abf","14":"d9036bd573745b53589b","15":"a35c97f54e7656941c67","16":"7b633f1ba0d16c330933","17":"74638669ae114c5596dc","18":"08b6ce56a3f7088ac8f6","19":"19f35bf6ee19f5f77149","20":"280db2ded54952ff2c77","21":"8ece026bd8d1576da15c","22":"26dc8bb11b5c13daebab","23":"1b263702db6d99f3a02d","24":"f2aaef6c7b37899aa606","25":"a79d991842016baf0f50","26":"d9dc1d7a9fb7109ce099","27":"f19ab67d8f9a57aa3dce","28":"3177398866a719f74674","29":"7580d7753a246d7e1f2d","30":"4d10d7444e42343e127c","31":"b6d7bf6736292c707781","32":"0c7a4a2efc8a52089d9b","33":"d387cd12abfe0683ac2b","34":"894161936530176d67b2","35":"46a44ee678323ddde30d","36":"c171a6fdba647ddf0448","37":"63b576529448f5f03290","38":"d5d8aa53302bfb9d05f4","39":"5e9b7289f34cc91662ba","40":"ac15d3ccd0bdc284881b","41":"66ca27fac39764bc925a","42":"388b0b9502ee455bce66","43":"3903648c64516467061f","44":"3af2e9275d3cd5f46d6d","45":"1a05069809ce16e35bd3","46":"660403cf95cd30f017c1","47":"495ee8c2a3a72cfdb4b7","48":"906529ffc858dfc13597","49":"74d22456360511539cec","50":"e5669f83f8aa4dd4cbd0","51":"81f1ab849889b723c555","52":"e12f4972ac1d99fbb04e","53":"3d35e01c59d9052cdbb3","54":"55490684650d9f9c7226","55":"ba9c0ee8048413fe3239","56":"26212b6761189d545033","57":"f04f8977e84f65c1a342","58":"cf2ebbb93d1e53acb456","59":"5ed1dec9b7304f2ecc07","60":"422724d9972a54375a6b","61":"5d18bb258ad83d0d7667","62":"52449584df948b2122e8","63":"50f09689df2523d0f9d0","64":"a34badd622ccdb7b175b","65":"77e607e4aa840727e911","66":"67993b42147c94ddc8ce","67":"a0acc70aa3e9c60ab4c2","68":"268bbb51a5fbc215aee3","69":"dd843924c4adb3e15ba9","70":"6616a2a5eb2d11346d4d","71":"0db62d045c98b9da215e","72":"3b403e04f7005eab5c8c","73":"3e3cbeb79d416cb93edd","74":"220fd246488e67318fcb","75":"03197370bc33682bec1f","76":"d19dc5baef0ac54005a4","77":"4b426572f9513e214eae","78":"89bc72b28291121b9058","79":"319a5c0b9c99242bf293","80":"a9f0f2fa271c18baedbf","81":"f00e674d1d9188ffb183","82":"88926d907736615a6bf3","83":"974d8365a815f136af61","84":"86e907bdcc67386f5aa4","85":"30f531e50e5526237637","86":"da63d8aaf8d574416434","87":"ec94eaaa6966b736c413","88":"1cba8f68c942e8b8ecf6","89":"2f1ad9d344324b0d0341","90":"8bc851c1a4dd98844715","91":"f984edfccb5cda8cd223","96":"8acbb03f8b77a3e00f0e"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/sites/2375-fix-explore-data-add-location-dropdown/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// run deferred modules from other chunks
 	checkDeferredModules();
